import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

// PAGES
import Home from "./pages/home/home.page";
import NotFound from "./pages/404/404.page";

// ROUTING
import Network from "./routing/network";
import Restaurants from "./routing/restaurants";
import Products from "./routing/products";
import Recipes from "./routing/receips";
import Workshops from "./routing/workshops";
import Privacy from "./routing/privacy";

class Routing extends Component {
  render() {
    return (
      <main>
        <Switch>
          <Route exact path={`/:lang?`} component={Home} />

          <Route path={`/pt/rede`} component={Network} />
          <Route path={`/pt/restaurantes`} component={Restaurants} />
          <Route path={`/pt/produtos`} component={Products} />
          <Route path={`/pt/receitas`} component={Recipes} />
          <Route path={`/pt/workshops`} component={Workshops} />
          <Route path={`/pt/privacidade`} component={Privacy} />

          <Route path={`/en/network`} component={Network} />
          <Route path={`/en/restaurants`} component={Restaurants} />
          <Route path={`/en/products`} component={Products} />
          <Route path={`/en/recipes`} component={Recipes} />
          <Route path={`/en/workshops`} component={Workshops} />
          <Route path={`/en/privacy`} component={Privacy} />

          <Route path={`/de/netzwerk`} component={Network} />
          <Route path={`/de/restaurants`} component={Restaurants} />
          <Route path={`/de/produkte`} component={Products} />
          <Route path={`/de/rezepte`} component={Recipes} />
          <Route path={`/de/workshops`} component={Workshops} />
          <Route path={`/de/privatsphare`} component={Privacy} />

          <Route path={`/fr/reseau`} component={Network} />
          <Route path={`/fr/restaurants`} component={Restaurants} />
          <Route path={`/fr/produits`} component={Products} />
          <Route path={`/fr/recettes`} component={Recipes} />
          <Route path={`/fr/workshops`} component={Workshops} />
          <Route path={`/fr/confidentialite`} component={Privacy} />

          <Route path={`/es/red`} component={Network} />
          <Route path={`/es/restaurantes`} component={Restaurants} />
          <Route path={`/es/productos`} component={Products} />
          <Route path={`/es/recetas`} component={Recipes} />
          <Route path={`/es/workshops`} component={Workshops} />
          <Route path={`/es/privatsphare`} component={Privacy} />

          <Route path={`/ja/network`} component={Network} />
          <Route path={`/ja/restaurants`} component={Restaurants} />
          <Route path={`/ja/products`} component={Products} />
          <Route path={`/ja/recipes`} component={Recipes} />
          <Route path={`/ja/workshops`} component={Workshops} />
          <Route path={`/ja/privacy`} component={Privacy} />

          <Route component={NotFound} />
        </Switch>
      </main>
    );
  }
}

export default Routing;



// WEBPACK FOOTER //
// ./src/routing.js